"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaCrime$ = exports.AreaCrime$outboundSchema = exports.AreaCrime$inboundSchema = void 0;
exports.areaCrimeToJSON = areaCrimeToJSON;
exports.areaCrimeFromJSON = areaCrimeFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.AreaCrime$inboundSchema = z.object({
    context: z.nullable(z.string()),
    crime_id: z.nullable(z.string()),
    crime_type: z.nullable(z.string()),
    falls_within: z.nullable(z.string()),
    last_outcome_category: z.nullable(z.array(z.string())),
    latitude: z.nullable(z.number()),
    location: z.nullable(z.string()),
    longitude: z.nullable(z.number()),
    lsoa_code: z.nullable(z.string()),
    lsoa_name: z.nullable(z.string()),
    month: z.nullable(z.string()),
    reported_by: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "crime_id": "crimeId",
        "crime_type": "crimeType",
        "falls_within": "fallsWithin",
        "last_outcome_category": "lastOutcomeCategory",
        "lsoa_code": "lsoaCode",
        "lsoa_name": "lsoaName",
        "reported_by": "reportedBy",
    });
});
/** @internal */
exports.AreaCrime$outboundSchema = z.object({
    context: z.nullable(z.string()),
    crimeId: z.nullable(z.string()),
    crimeType: z.nullable(z.string()),
    fallsWithin: z.nullable(z.string()),
    lastOutcomeCategory: z.nullable(z.array(z.string())),
    latitude: z.nullable(z.number()),
    location: z.nullable(z.string()),
    longitude: z.nullable(z.number()),
    lsoaCode: z.nullable(z.string()),
    lsoaName: z.nullable(z.string()),
    month: z.nullable(z.string()),
    reportedBy: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        crimeId: "crime_id",
        crimeType: "crime_type",
        fallsWithin: "falls_within",
        lastOutcomeCategory: "last_outcome_category",
        lsoaCode: "lsoa_code",
        lsoaName: "lsoa_name",
        reportedBy: "reported_by",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var AreaCrime$;
(function (AreaCrime$) {
    /** @deprecated use `AreaCrime$inboundSchema` instead. */
    AreaCrime$.inboundSchema = exports.AreaCrime$inboundSchema;
    /** @deprecated use `AreaCrime$outboundSchema` instead. */
    AreaCrime$.outboundSchema = exports.AreaCrime$outboundSchema;
})(AreaCrime$ || (exports.AreaCrime$ = AreaCrime$ = {}));
function areaCrimeToJSON(areaCrime) {
    return JSON.stringify(exports.AreaCrime$outboundSchema.parse(areaCrime));
}
function areaCrimeFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.AreaCrime$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'AreaCrime' from JSON`);
}
//# sourceMappingURL=areacrime.js.map